import React, { useState, useEffect, useMemo } from "react";
import { ExchangeTransactions } from "../../pages";
import { ExchangeController } from "../../controllers";
import { toJS } from "mobx";
import { exchangeStore } from "../../stores";

const ExchangeTransactionsContainer = () => {
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [fromCurrency, setFromCurrency] = useState("NGN");

  const exchangeTranTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}&fromCurrency=${fromCurrency}`;
  }, [currentPage, limit, fromCurrency]);

  const { isLoading, data, isFetching } =
    ExchangeController.useGetExchangeTransactions(
      exchangeTranTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  useEffect(() => {
    const fetchExchangeTransactions = async () => {
      setLoading(true);
      await Promise.all([ExchangeController.getExchangeAnalysis()]);
      setLoading(false);
    };
    fetchExchangeTransactions();
  }, []);

  const filterHandler = async (query) => {
    setLoading2(true);
    setFilterQuery(query);
    await Promise.all([ExchangeController.getExchangeAnalysis(query)]);
    setLoading2(false);
  };

  return (
    <ExchangeTransactions
      loading={loading}
      loading2={loading2}
      exchangeTransactions={toJS(exchangeStore.exchangeTransactions)}
      exchangeAnalysis={toJS(exchangeStore.exchangeAnalysis)}
      filterHandler={filterHandler}
      isLoading={isLoading}
      data={data}
      isFetching={isFetching}
      limit={limit}
      onLimitChange={onLimitChange}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setSearchQuery={setSearchQuery}
      setFilterQuery={setFilterQuery}
      setFromCurrency={setFromCurrency}
    />
  );
};

export default ExchangeTransactionsContainer;
